<div class="biometrics-container">
    <div class="pin-container hide1">
        <div class="step-container flex">
            <!-- step-1 -->
            <span class="step-val active ">
                <span class="step-circle active">

                    <span class="hide">
                        <f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon>
                    </span>
                    <span class="step-no">1</span>
                </span>Request Biometrics</span>
            <!-- step-2 -->
            <span class="step-val step-val-next">
                <span class="step-circle ">
                    <span class="hide">
                        <f-icon icon-config='{"iconName": "check", "iconType": "solid", "iconSize": "s"}'></f-icon>
                    </span>
                    <span class="step-no">2</span>
                </span>Biometric verification</span>

        </div>
    </div>

    <div class="biometric-authentication">
        <!-- Step 1 content -->
        <div class="request-biometric hide1">
            <div class="error-wrapper hide1">
                <f-alert variant="error"> The biometric verification request could not be completed. Click the Retry
                    button to try again.
                </f-alert>
            </div>
            <div class="biometric-content step1-content">
                <p>This caller is registered for biometric verification. Send a biometric request to user's registered
                    mobile device to authenticate the call.</p>

            </div>
        </div>

         <!-- Step 2 content -->
        <div class="biometric-verification hide">
            <div class="error-wrapper hide1">
                <f-alert variant="error"> Biometric verification was unsuccessful. Click the Retry button to try again.
                </f-alert>
            </div>
            <div class="biometric-content step2-content">
                <p> A biometric verification request has been sent to the caller's registered mobile device.</p>

                <div class="text-with-loader flex">
                      <p>AIDV verification status: <strong>In progress </strong></p> <mat-progress-spinner class="section-loader"
                        [color]="color" [mode]="mode" [value]="value" [diameter]="16"
                        style="display:inline-block;"></mat-progress-spinner>
                </div>

                    <div>
                        <p class="instruction-heading"><strong>What happens next?</strong></p>
                        <p>
                            1. The caller will receive a push notification on the registered mobile device.
                        </p>
                        <p>
                            2.The caller will be prompted to verify using Face ID or Fingerprint.
                        </p>
                        <p>
                            3.Once verification is complete, the call will get authenticated.
                        </p>
                    </div>

                     <p>Caller didn't receive the notification? <a href="javascript:void('0')" class="btn-alert-link">Resend Biometric Request</a>
                    </p>
            </div>
        </div>

        <div class="btn-refresh-container flex">
            <div class="btn-controls">
                <f-button text="Send Biometric Request" title="Send Biometric Request" type="button"
                    variant="progressive" class="hide"></f-button>
                     <f-button text="Cancel" title="Cancel" type="button"
                    variant="action" class="hide1"></f-button>
                     <f-button text="Retry" title="Retry" type="button"
                    variant="progressive" class="hide1"></f-button>
            </div>
        </div>
    </div>
</div>